import React, { useState } from "react";
import ModalWrapper from "../../components/elements/ModalWrapper";
import ModalConfirmation from "../../components/fragments/ModalConfirmation";
import FormMasterLevel from "./FormMasterLevel";
import { useMutation } from "@tanstack/react-query";
import { saveImage } from "../../services/masterLevel";
import { showNotification } from "../../utilities/mantineNotification";
import { LoadingOverlay } from "@mantine/core";
import Loader from "../../components/fragments/Loader";

interface CreateMasterLevelProps {
  isVisible: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  data: any;
  type: string;
}

const CreateMasterLevel: React.FC<CreateMasterLevelProps> = ({
  isVisible,
  onSubmit,
  onClose,
  loading,
  data,
  type,
}) => {
  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null,
  });

  const handleSubmitData = (data: any) => {
    setModalDialog({
      show: true,
      data: data,
    });
  };

  const uploadImage = useMutation({
    mutationFn: (data: any) =>
      saveImage({
        FileName: data.levelImage.fileName,
        FileData: data.levelImage.base64,
      }),
    onSuccess: (response) => {
      const imageUrl = response.data.data.filePath;
      showNotification({
        type: "success",
        title: "Success Upload Image",
        message: "Image has been uploaded",
      });
      setModalDialog({
        show: false,
        data: null,
      });
      onSubmit({ ...modalDialog.data, levelImage: imageUrl });
    },
    onError: (error: any) => {
      console.error("error", error);
      showNotification({
        type: "error",
        message: error?.errorMessage
          ? JSON.stringify(error?.errorMessage)
          : "Failed to upload image. Please change the image into .png/.jpg and try again.",
      });
    },
  });

  const handleConfirm = () => {
    if (modalDialog.data.levelImage !== data.levelImage) {
      const payload = {
        ...modalDialog.data,
        levelImage: JSON.parse(modalDialog.data.levelImage),
      };
      uploadImage.mutate(payload);
      return;
    }
    setModalDialog({
      show: false,
      data: null,
    });
    onSubmit(modalDialog.data);
  };

  return (
    <>
      <ModalWrapper
        title={`${type === "edit" ? "Update" : "Create"} Master Level`}
        isVisible={isVisible}
        onClose={onClose}
      >
        <FormMasterLevel
          onClose={onClose}
          loading={loading}
          handleSubmitData={handleSubmitData}
          type={type}
          data={data}
        />
      </ModalWrapper>

      <ModalConfirmation
        isVisible={modalDialog.show}
        type={type}
        onCancel={() => {
          setModalDialog({
            show: false,
            data: null,
          });
        }}
        onConfirm={handleConfirm}
      />

      <LoadingOverlay
        visible={uploadImage.isLoading}
        loaderProps={{ children: <Loader message="Uploading image..." /> }}
      />
    </>
  );
};

export default CreateMasterLevel;
